import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../components/Common/Particle";
import Github from "../components/About/Github";
import Techstack from "../components/About/Techstack";
import AboutCard from "../components/About/AboutCard";
import laptopImg from "../Assets/about.png";
import Toolstack from "../components/About/Toolstack";

function About() {
    return (
        <Container fluid className="about-section">
            <Particle />
            <Container>
                <Row style={{ justifyContent: "center", padding: "10px" }}>
                    <Col md={7} className="about-card-col">
                        <h1
                            style={{ fontSize: "2.1em", paddingBottom: "20px" }}
                        >
                            Know Who <strong className="purple">I'M</strong>
                        </h1>
                        <AboutCard />
                    </Col>
                    <Col md={5} className="about-img-col">
                        <img
                            src={laptopImg}
                            alt="about"
                            className="img-fluid"
                        />
                    </Col>
                </Row>
                <h1 className="project-heading">
                    Professional <strong className="purple">Skillset </strong>
                </h1>

                <Techstack />

                <h1 className="project-heading">
                    <strong className="purple">Tools</strong> I use
                </h1>
                <Toolstack />

                <Github />
            </Container>
        </Container>
    );
}

export default About;
